<div
    class="supplier-overview--wrapper"
    data-testid="t-overview-div-1752672977568-11"
>
    <app-title-bar
        [title]="'mws.supplier' | i18n"
        [subtitle]="'mws.overview' | i18n"
        [showFilterDropdown]="showBlacklisted ? false : true"
        [searchBar]="showBlacklisted ? false : true"
        (searchbarEvent)="onSearchbarEvent($event)"
        [showSearchBarFilter]="false"
        [filterMessageTexts]="filterMessageTexts"
        (filterClick)="getSuppliersOverviewWithFilterAndSearchbox($event, tempSearch)"
        [filterDefault]="2"
        data-testid="t-overview-app-title-bar-1752672977568-1"
    ></app-title-bar>

    <div
        class="supplier-overview--list"
        data-testid="t-overview-div-1752672977568-10"
    >
        <div
            class="layout-grid"
            data-testid="t-overview-div-1752672977568-9"
        >
            <div
                class="scrolling--col sidebar-column--buttons"
                data-testid="t-overview-div-1752672977568-5"
            >
                <div
                    class="sidebar--button-grid"
                    data-testid="t-overview-div-1752672977568-4"
                >
                    @if (coreService.checkAbility('execute', 'supplier.new')) {
                        <div
                            class="grid-item"
                            data-testid="t-overview-div-1752672977568-1"
                        >
                            <app-overview-selectcard
                                [icon]="'oc-plus'"
                                [cardTitle]="'mws.createnew' | i18n"
                                [routerLink]="'/mwsp/supplier/detail/NEW'"
                                data-testid="t-overview-app-overview-selectcard-1752672977568-1"
                            ></app-overview-selectcard>
                        </div>
                    }

                    <div
                        class="grid-item"
                        data-testid="t-overview-div-1752672977568-2"
                    >
                        <app-overview-selectcard
                            [icon]="'oc-supplier'"
                            [cardTitle]="'mws.supplier.overview' | i18n"
                            [styleClass]="showBlacklisted ? '' : 'card-selected'"
                            (click)="getSuppliersOverviewWithFilterAndSearchbox(titleBarFilter.ENABLED, '')"
                            data-testid="t-overview-app-overview-selectcard-1752672977568-2"
                        ></app-overview-selectcard>
                    </div>

                    <div
                        class="grid-item"
                        data-testid="t-overview-div-1752672977568-3"
                    >
                        <app-overview-selectcard
                            [icon]="'oc-supplierarchived'"
                            [cardTitle]="'mws.supplier.overview.archived' | i18n"
                            [styleClass]="showBlacklisted ? 'card-selected' : ''"
                            (click)="getSuppliersBlacklisted()"
                            data-testid="t-overview-app-overview-selectcard-1752672977568-3"
                        ></app-overview-selectcard>
                    </div>

                    <!--                        <div class="grid-item" *ngIf="('execute' | ablePure: 'supplier.import' | async)">-->
                    <!--                            <app-overview-selectcard-->
                    <!--                                [icon]="'oc-plus'"-->
                    <!--                                [cardTitle]="('mws.record' | i18n) + ' ' + ('mws.import' | i18n)"-->
                    <!--                                (click)="importData()"-->
                    <!--                            ></app-overview-selectcard>-->
                    <!--                        </div>-->
                </div>
            </div>

            <div
                class="scrolling--col"
                data-testid="t-overview-div-1752672977568-8"
            >
                @if (coreService.checkAbility('execute', 'supplier.new')) {
                    <div
                        class="card-grid"
                        data-testid="t-overview-div-1752672977568-7"
                    >
                        @for (s of supplierService.supplierOverview; track s) {
                            <div
                                class="grid-item"
                                data-testid="t-overview-div-1752672977568-6"
                            >
                                <!--                        [imagePath]="environmentService.getURL(environmentService.appSettings.fakeServer) + '/supplierIcon?language=' + environmentService.appSettings.locale + '&supplierIconId='"-->
                                <app-overview-card
                                    [privilegeContext]="'supplier.'"
                                    [imagePath]="imageService.getImageUrl({ imageId: s.imageId, imageFilename: undefined }, undefined)"
                                    [imgId]="s.imageId"
                                    [showRating]="false"
                                    [rating]="0"
                                    [title]="s.name"
                                    [cardDescriptions]="utilityHelper.buildCardDescription(s.address ? s.address.city : '', '')"
                                    [states]="s.supplierStatus"
                                    [showStateCount]="true"
                                    (action)="selectSupplier(s.id, s.supplierStatus[0].costcenterId)"
                                    data-testid="t-overview-app-overview-card-1752672977568-1"
                                ></app-overview-card>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
</div>
